common.View.create('shop::canvas.blocks.shop.contentImageTiles.Block', {

    onDOMLoad()
    {
        this.initSlider();
    },

    initSlider()
    {
        this.element.find('.owl-carousel')
            .owlCarousel({
                loop: true,
                margin: 30,
                nav: true, // this.element.find('.owl-carousel').data('show-navigation')
                navText : ["<i class='fal fa-angle-left'></i>","<i class='fal fa-angle-right'></i>"],
                dots: false,
                autoplay: false,
                responsive: {
                    0: {
                        items: 1
                    },
                    640: {
                        items: 1,
                        stagePadding: 120,
                    },
                }
            });
    }

});
